"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Player = void 0;
var programs_query_1 = require("./queries/programs-query");
var typings_1 = require("./typings");
var graphql_1 = require("./typings/graphql");
var utilities_1 = require("./utilities");
var helpers_1 = require("./helpers/");
var config_1 = require("../../config");
var models_1 = require("./models");
var drm_1 = require("./drm");
var utilities_2 = require("./utilities");
var constants_1 = require("./constants");
var CafSender_1 = __importDefault(require("./utilities/CafSender"));
var createElement_1 = __importDefault(require("./utilities/createElement"));
var AUTOPLAY_BUTTONS;
(function (AUTOPLAY_BUTTONS) {
    AUTOPLAY_BUTTONS["cancel"] = "cancel";
    AUTOPLAY_BUTTONS["play"] = "play now";
})(AUTOPLAY_BUTTONS || (AUTOPLAY_BUTTONS = {}));
var DEFAULT_SECONDS_TO_AUTOPLAY = 5;
var Player = (function () {
    function Player(config, callback) {
        var _this = this;
        this.relatedPlaylist = [];
        this.relatedLoaded = false;
        this.playlist = [];
        this.adheseFailed = false;
        this.DOM = {
            container: null,
            ratio: null,
        };
        this.playbackStarted = false;
        this.relatedOverlaySeen = 0;
        this.autoStartTimeout = null;
        this.handleAutoPlayClick = function (action) {
            return function (e) {
                var _a;
                e.stopPropagation();
                _this.cancelAutoStart();
                if (action === 'play') {
                    ;
                    _this.jwplayer.playlistNext();
                    (0, utilities_2.trackEndcardPlayNow)();
                    return;
                }
                (0, utilities_2.trackEndcardCancel)();
                var nextUpText = document.querySelector('.jw-related-next-up-text');
                if (nextUpText) {
                    nextUpText.style.display = 'block';
                }
                (_a = document.querySelector('.next-auto-play')) === null || _a === void 0 ? void 0 : _a.remove();
            };
        };
        this.appVersion = config_1.version;
        this.clientConfig = config;
        this.consent = config.consent || null;
        this.setup(callback);
        this.nextUpIn = DEFAULT_SECONDS_TO_AUTOPLAY;
        this.onRelatedReady = this.relatedReadyHandler.bind(this);
        this.onRelatedPlaylist = this.relatedPlaylistHandler.bind(this);
        this.onInitAutoStart = this.initAutoStart.bind(this);
    }
    Player.prototype.setup = function (callback) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var _d, playerScript, _e, e_1, errorMessage;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 6, , 7]);
                        _d = this;
                        return [4, (0, utilities_1.getPlayerConfig)({
                                playerConfigUrl: this.clientConfig.playerConfigUrl,
                                token: (_a = this.clientConfig) === null || _a === void 0 ? void 0 : _a.token,
                                referrer: (_b = this.clientConfig) === null || _b === void 0 ? void 0 : _b.referrer,
                            })];
                    case 1:
                        _d.apiConfig = _f.sent();
                        if (!this.apiConfig) return [3, 5];
                        this.videoApiEndpoint =
                            this.clientConfig.videoApiEndpoint || this.apiConfig.dataSource.apiEndpoint || config_1.KIJK_API_URL;
                        this.playerConfig = new models_1.PlayerConfig(this.clientConfig, this.apiConfig);
                        playerScript = ((_c = this.apiConfig.playerProvider) === null || _c === void 0 ? void 0 : _c.script) || config_1.defaultPlayerScript;
                        this.jwVersion = (0, utilities_2.getJwPlayerVersion)(playerScript);
                        _e = this;
                        return [4, this.getPlaylist(this.clientConfig.playlist)];
                    case 2:
                        _e.playlist = _f.sent();
                        this.playerConfig.playlist = this.playlist;
                        if (!this.playlist || this.playlist.every(function (item) { return item.isAvailable === false; })) {
                            throw new Error(constants_1.SETUP_ERRORS.EMPTY_PLAYLIST);
                        }
                        return [4, (0, helpers_1.createScript)(playerScript, window.document)];
                    case 3:
                        _f.sent();
                        return [4, this.playerInit()];
                    case 4:
                        _f.sent();
                        _f.label = 5;
                    case 5: return [3, 7];
                    case 6:
                        e_1 = _f.sent();
                        errorMessage = typeof e_1 === 'string' ? e_1 : e_1 === null || e_1 === void 0 ? void 0 : e_1.message;
                        this.error = {
                            message: errorMessage,
                            group: (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.indexOf(' - ')) ? errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.split(' - ')[0] : 'Default setup player error group',
                        };
                        console.error(e_1);
                        return [3, 7];
                    case 7:
                        typeof callback === 'function' ? callback(this) : null;
                        return [2];
                }
            });
        });
    };
    Player.prototype.getPlaylist = function (videoIds) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!_this.clientConfig.playlist) {
                return resolve([]);
            }
            (0, utilities_1.fetchPrograms)({
                videoApiEndpoint: _this.videoApiEndpoint,
                query: programs_query_1.programsQuery,
                variables: { guid: videoIds },
            })
                .then(function (playlist) {
                if (!playlist.length) {
                    return reject(constants_1.SETUP_ERRORS.PLAYLIST_NO_RESULTS);
                }
                _this.setupDrm(playlist);
                resolve(playlist);
            })
                .catch(function (err) {
                reject("".concat(constants_1.SETUP_ERRORS.PLAYLIST_ERROR, " - ").concat(err.message));
            });
        });
    };
    Player.prototype.setPlaylist = function (playlist) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4, this.getPlaylist(playlist)];
                    case 1:
                        response = (_a.sent());
                        this.playlist = response;
                        if (!this.jwplayer) return [3, 2];
                        this.jwplayer.load(response);
                        return [3, 4];
                    case 2:
                        this.playerConfig.playlist = response;
                        return [4, this.playerInit()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        resolve(true);
                        return [3, 6];
                    case 5:
                        err_1 = _a.sent();
                        console.error(err_1);
                        reject(err_1);
                        return [3, 6];
                    case 6: return [2];
                }
            });
        }); });
    };
    Player.prototype.getPlayerToken = function () {
        var _a;
        return (_a = this.clientConfig) === null || _a === void 0 ? void 0 : _a.token;
    };
    Player.prototype.setupDrm = function (playlist) {
        this.drm = new drm_1.Drm(this.videoApiEndpoint);
        this.drm.init(playlist);
    };
    Player.prototype.playerInit = function () {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            var player, JwMonitor;
            var _this = this;
            return __generator(this, function (_f) {
                if ((_b = (_a = this.playerConfig) === null || _a === void 0 ? void 0 : _a.skin) === null || _b === void 0 ? void 0 : _b.url) {
                    (0, helpers_1.loadCssFile)(this.playerConfig.skin.url, (_c = this.clientConfig) === null || _c === void 0 ? void 0 : _c.token);
                    this.playerConfig.skin.url = null;
                }
                this.initTime = Date.now();
                player = jwplayer(this.clientConfig.containerId);
                this.jwplayer = player;
                player.setup(__assign(__assign({}, this.playerConfig), { logo: null }));
                this.jwplayer.setPlaylistItemCallback(function (item) { return __awaiter(_this, void 0, void 0, function () {
                    var metadata, guid, adheseConfig;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!this.playerConfig.advertising) {
                                    return [2, item];
                                }
                                metadata = item.metadata, guid = item.guid;
                                return [4, (0, helpers_1.getAdheseConfig)(guid, ((_a = this.consent) === null || _a === void 0 ? void 0 : _a.tcString) || '')];
                            case 1:
                                adheseConfig = _b.sent();
                                this.adheseFailed = adheseConfig === null;
                                if (this.adheseFailed) {
                                    (0, utilities_2.setDataLayer)({
                                        app_adsenseid: "adblok:true",
                                    });
                                }
                                item.freewheel = {
                                    custom: __assign(__assign(__assign({}, adheseConfig), this.playerConfig.advertising.freewheel.custom), { media_videotype: metadata.media_videotype, vdur: metadata.media_duration, cd_type: metadata.c_media_duration_type }),
                                };
                                return [2, item];
                        }
                    });
                }); });
                if (typeof window.TVA !== 'undefined') {
                    JwMonitor = window.TVA.getPlugin('JWMonitor');
                    JwMonitor.init({
                        defaultLayer: {
                            player_version: this.jwVersion,
                            player_channel: (_d = this.playerConfig) === null || _d === void 0 ? void 0 : _d.slug,
                            player_channelid: (_e = this.playerConfig) === null || _e === void 0 ? void 0 : _e.slug,
                            player_id: 'embedded_3p',
                            player_name: 'jwplayer',
                        },
                        events: {
                            playlist: function () { return false; },
                            playlistItem: function () { return _this.playbackStarted === true; },
                            remove: function () { return false; },
                        },
                    });
                }
                this.initEvents();
                return [2];
            });
        });
    };
    Player.prototype.initEvents = function () {
        this.jwplayer.on('ready', this.readyHandler.bind(this));
        this.jwplayer.on('playlistItem', this.playlistItemHandler.bind(this));
        this.jwplayer.on('firstFrame', this.firstFrameHandler.bind(this));
        this.jwplayer.on('complete', this.completeHandler.bind(this));
        this.jwplayer.on('playlistComplete', this.playlistCompleteHandler.bind(this));
        this.jwplayer.on('mute', this.muteHandler.bind(this));
        this.jwplayer.on('volume', this.volumeHandler.bind(this));
        this.jwplayer.on('beforePlay', this.beforePlayHandler.bind(this));
        this.jwplayer.on('captionsChanged', this.captionsChangedHandler.bind(this));
        this.jwplayer.on('levels', this.levelsHandler.bind(this));
        this.jwplayer.on('visualQuality', this.visualQualityHandler.bind(this));
    };
    Player.prototype.readyHandler = function () {
        var _a, _b, _c, _d;
        var chromecastReceiverId = this.clientConfig.chromecastReceiverId || ((_a = this.apiConfig.skin) === null || _a === void 0 ? void 0 : _a.chromecastReceiverId);
        if ((0, helpers_1.isChrome)() && chromecastReceiverId) {
            this.cafSender = new CafSender_1.default({
                applicationId: chromecastReceiverId,
                jwplayer: this.jwplayer,
                videoApiEndpoint: this.videoApiEndpoint,
                freewheelConfig: (_c = (_b = this.playerConfig) === null || _b === void 0 ? void 0 : _b.advertising) === null || _c === void 0 ? void 0 : _c.freewheel,
                playerChannel: (_d = this.playerConfig) === null || _d === void 0 ? void 0 : _d.slug,
            });
        }
        this.addLogoWrapper();
        (0, helpers_1.addNicamStylesheet)(this.playerConfig);
        (0, helpers_1.addTitleStylesheet)(this.playerConfig);
    };
    Player.prototype.beforePlayHandler = function () {
        this.playbackStarted = true;
        if (typeof window.__tcfapi !== 'undefined' && window.ON_TALPA_DOMAIN) {
            this.addConsentButton();
        }
    };
    Player.prototype.captionsChangedHandler = function (_a) {
        var _b;
        var track = _a.track, tracks = _a.tracks;
        if (((_b = this.cafSender) === null || _b === void 0 ? void 0 : _b.isCasting) && tracks[track]) {
            this.cafSender.setActiveTrack(tracks[track].id);
        }
    };
    Player.prototype.completeHandler = function () {
        if (!this.relatedPlaylist.length) {
            return;
        }
        var currentIndex = this.jwplayer.getPlaylistIndex();
        if (currentIndex < this.playlist.length - 1) {
            return;
        }
        if (this.relatedLoaded) {
            this.jwplayer.stop();
            this.jwplayer.getPlugin('related').open();
            if (this.playerConfig.endCard.autoplay)
                this.onInitAutoStart();
            (0, utilities_2.trackRelatedView)(++this.relatedOverlaySeen);
            return;
        }
    };
    Player.prototype.relatedReadyHandler = function () {
        var _this = this;
        this.jwplayer.off('relatedReady', this.onRelatedReady);
        this.jwplayer.stop();
        setTimeout(function () {
            var relatedPlugin = _this.jwplayer.getPlugin('related');
            relatedPlugin.open();
            _this.playerConfig.endCard.autoplay && _this.onInitAutoStart();
            relatedPlugin.on('feedClick', _this.onFeedClick.bind(_this));
            relatedPlugin.on('close', _this.cancelAutoStart);
            (0, utilities_2.trackRelatedView)(++_this.relatedOverlaySeen);
        });
    };
    Player.prototype.relatedPlaylistHandler = function () {
        this.relatedLoaded = true;
        this.jwplayer.stop();
        this.jwplayer.off('playlistItem', this.onRelatedPlaylist);
        if (this.playlist.length > 1) {
            this.jwplayer.playlistItem(this.playlist.length - 1);
        }
    };
    Player.prototype.playlistCompleteHandler = function () {
        if (this.relatedLoaded)
            return;
        if (!this.relatedPlaylist.length)
            return;
        this.jwplayer.on('relatedReady', this.onRelatedReady);
        this.jwplayer.on('playlistItem', this.onRelatedPlaylist);
        console.log("onPlaylistComplete > load related playlist: \n - ".concat(this.relatedPlaylist
            .map(function (_a) {
            var title = _a.title;
            return title;
        })
            .join('\n - ')));
        this.jwplayer.load(this.relatedPlaylist);
    };
    Player.prototype.addConsentButton = function () {
        var consentButton = document.getElementById('gdpr-toggle');
        if (consentButton) {
            consentButton.style.visibility = 'hidden';
        }
        this.jwplayer.addButton('', 'Cookie Instellingen', function () {
            ;
            window.__tcfapi('showConsentManager');
        }, 'cookie-setting-button');
    };
    Player.prototype.playlistItemHandler = function (_a) {
        var _b;
        var index = _a.index, item = _a.item;
        this.activeItem = index;
        this.container = this.container || document.getElementById(this.clientConfig.containerId);
        this.addNicamIconsHolder();
        this.setTitleAndDescription();
        this.stylePlayButton();
        this.addFullEpisodeButton();
        if (((_b = this.playerConfig) === null || _b === void 0 ? void 0 : _b.logo.linkType) === typings_1.LinkType.KIJK) {
            var logo = document.querySelector('a.jw-logo');
            if (logo)
                logo.href = item.kijkLink;
        }
    };
    Player.prototype.setDefaultCaption = function () {
        var _a;
        this.container = this.container || document.getElementById(this.clientConfig.containerId);
        this.setTitleAndDescription();
        if (localStorage.getItem('jwplayer.captionLabel')) {
            return;
        }
        var captions = (_a = this.jwplayer) === null || _a === void 0 ? void 0 : _a.getCaptionsList();
        var captionIndex = captions === null || captions === void 0 ? void 0 : captions.findIndex(function (caption) { return caption.label === constants_1.CAPTION_DUTCH; });
        if (captionIndex >= 0) {
            this.jwplayer.setCurrentCaptions(captionIndex);
        }
    };
    Player.prototype.loadRelatedPlaylist = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var firstPlaylistItem, type, tvSeasonId, _b, enabled, supportedVideoTypes, relatedPrograms, relatedPlaylist, hasNewItems;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!((_a = this.playlist) === null || _a === void 0 ? void 0 : _a.length))
                            return [2];
                        firstPlaylistItem = this.playlist[0];
                        type = firstPlaylistItem.type, tvSeasonId = firstPlaylistItem.tvSeasonId;
                        _b = this.playerConfig.endCard, enabled = _b.enabled, supportedVideoTypes = _b.supportedVideoTypes;
                        if (!supportedVideoTypes.includes(type) || !tvSeasonId || !enabled || this.relatedPlaylist.length) {
                            return [2];
                        }
                        this.jwplayer.on('nextClick', utilities_2.trackNextUpClick);
                        return [4, (0, utilities_1.fetchPrograms)({
                                videoApiEndpoint: this.videoApiEndpoint,
                                query: programs_query_1.programsByTvSeasonId,
                                variables: {
                                    tvSeasonId: tvSeasonId,
                                    programTypes: type,
                                    skip: 0,
                                    limit: 100,
                                },
                            })];
                    case 1:
                        relatedPrograms = _c.sent();
                        relatedPlaylist = relatedPrograms.length
                            ? type === graphql_1.ProgramTypes.CLIP
                                ? (0, helpers_1.sortRelatedClips)(this.playlist, relatedPrograms)
                                : (0, helpers_1.sortRelatedEpisodes)(this.playlist, relatedPrograms)
                            : [];
                        hasNewItems = relatedPlaylist.some(function (_a) {
                            var relatedGuid = _a.guid;
                            return !_this.playlist.some(function (_a) {
                                var guid = _a.guid;
                                return relatedGuid === guid;
                            });
                        });
                        if (!hasNewItems)
                            return [2];
                        this.relatedPlaylist = relatedPlaylist;
                        this.drm.init(this.relatedPlaylist);
                        return [2];
                }
            });
        });
    };
    Player.prototype.firstFrameHandler = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                this.setDefaultCaption();
                this.loadRelatedPlaylist();
                if ((_a = this.clientConfig.playbackOptions) === null || _a === void 0 ? void 0 : _a.start) {
                    this.jwplayer.seek(this.clientConfig.playbackOptions.start);
                }
                return [2];
            });
        });
    };
    Player.prototype.muteHandler = function (_a) {
        var _b;
        var mute = _a.mute;
        this.playerConfig.mute = mute;
        if ((_b = this.cafSender) === null || _b === void 0 ? void 0 : _b.isCasting) {
            this.cafSender.setMute(mute);
        }
    };
    Player.prototype.volumeHandler = function (_a) {
        var _b;
        var volume = _a.volume;
        if ((_b = this.cafSender) === null || _b === void 0 ? void 0 : _b.isCasting) {
            this.cafSender.setVolume(Math.round(volume) / 100);
        }
    };
    Player.prototype.levelsHandler = function () {
        var subtitleMenu = document.querySelector('#jw-settings-submenu-quality .jw-settings-submenu-items');
        if (subtitleMenu) {
            var qualityLevels_1 = [];
            subtitleMenu.childNodes.forEach(function (item) {
                var buttonText = item.innerHTML;
                if (buttonText.match(/^\d+p\s{1}\(.+\)/)) {
                    var label = buttonText.split(' ')[0];
                    item.innerHTML = label;
                    if (qualityLevels_1.includes(label)) {
                        item.style.display = 'none';
                        return;
                    }
                    qualityLevels_1.push(label);
                }
            });
        }
    };
    Player.prototype.visualQualityHandler = function (_a) {
        var level = _a.level;
        var isHD = level === null || level === void 0 ? void 0 : level.label.includes('1080p');
        var container = this.jwplayer.getContainer();
        container.classList.toggle('hd-selected', isHD);
    };
    Player.prototype.setTitleAndDescription = function () {
        var _a, _b, _c;
        if ((_a = this.playerConfig) === null || _a === void 0 ? void 0 : _a.displaytitle) {
            this.setDisplayTitle(this.playerConfig.displaytitle);
        }
        if ((_b = this.playerConfig) === null || _b === void 0 ? void 0 : _b.displaydescription) {
            this.setDisplayDescription((_c = this.playerConfig) === null || _c === void 0 ? void 0 : _c.displaydescription);
        }
    };
    Player.prototype.cancelAutoStart = function () {
        if (this.autoStartTimeout) {
            clearTimeout(this.autoStartTimeout);
        }
        this.nextUpIn = DEFAULT_SECONDS_TO_AUTOPLAY;
    };
    Player.prototype.createAutoPlayButton = function (action) {
        var button = document.createElement('button');
        button.innerText = AUTOPLAY_BUTTONS[action];
        button.onclick = this.handleAutoPlayClick(action);
        return button;
    };
    Player.prototype.initAutoStart = function () {
        var _this = this;
        var nextUpText = document.querySelector('.jw-related-next-up-text');
        if (!(nextUpText === null || nextUpText === void 0 ? void 0 : nextUpText.parentNode)) {
            return;
        }
        if (this.nextUpIn === 0) {
            this.nextUpIn = DEFAULT_SECONDS_TO_AUTOPLAY;
            nextUpText.style.display = 'block';
            this.jwplayer.playlistNext();
            (0, utilities_2.trackEndcardAutoplay)();
            return;
        }
        if (this.jwplayer.getPlaylist().length - 1 === this.activeItem) {
            this.cancelAutoStart();
            return;
        }
        nextUpText.style.display = 'none';
        var nextUpAutoPlay = document.querySelector('.next-auto-play');
        if (!nextUpAutoPlay) {
            nextUpAutoPlay = document.createElement('div');
            nextUpAutoPlay.className = 'next-auto-play';
            nextUpAutoPlay.innerHTML = "\n      <p><strong>Up Next in <span id=\"next-up-counter\" style=\"color:white\"></span></strong></p>\n    ";
            Object.keys(AUTOPLAY_BUTTONS).forEach(function (action) {
                var button = _this.createAutoPlayButton(action);
                nextUpAutoPlay === null || nextUpAutoPlay === void 0 ? void 0 : nextUpAutoPlay.append(button);
            });
            nextUpText.parentNode.prepend(nextUpAutoPlay);
        }
        var counter = document.getElementById('next-up-counter');
        if (counter) {
            counter.innerText = "".concat(this.nextUpIn--);
        }
        this.autoStartTimeout = window.setTimeout(this.onInitAutoStart, 1000);
    };
    Player.prototype.onFeedClick = function (event) {
        this.cancelAutoStart();
        (0, utilities_2.trackRelatedClick)({ index: event.index });
    };
    Player.prototype.stylePlayButton = function () {
        var _a;
        if ((_a = this.playerConfig) === null || _a === void 0 ? void 0 : _a.skin.playButtonBackground) {
            this.container = this.container || document.getElementById(this.clientConfig.containerId);
            if (!this.container)
                return;
            var playButton = this.container.querySelector('div.jw-display-icon-container.jw-display-icon-display.jw-reset');
            if (playButton) {
                playButton.style.backgroundColor = this.playerConfig.skin.playButtonBackground;
                playButton.style.borderRadius = '50%';
            }
        }
    };
    Player.prototype.play = function () {
        this.jwplayer.play();
    };
    Player.prototype.pause = function () {
        this.jwplayer.pause();
    };
    Player.prototype.stop = function () {
        this.jwplayer.stop();
    };
    Player.prototype.getPosition = function () {
        return this.jwplayer.getPosition();
    };
    Player.prototype.getDuration = function () {
        return this.jwplayer.getDuration();
    };
    Player.prototype.getRepeat = function () {
        return this.playerConfig.repeat;
    };
    Player.prototype.getControls = function () {
        return this.playerConfig.controls;
    };
    Player.prototype.setControls = function (controls) {
        if (typeof controls === 'undefined') {
            return;
        }
        this.jwplayer.setControls(controls);
        this.playerConfig.controls = controls;
    };
    Player.prototype.getDisplayTitle = function () {
        return this.playerConfig.displaytitle;
    };
    Player.prototype.setDisplayTitle = function (displayTitle) {
        if (typeof displayTitle === 'undefined') {
            return;
        }
        this.container = this.container || document.getElementById(this.clientConfig.containerId);
        if (!this.container)
            return;
        var titleWrapper = this.container.querySelector('.jw-title');
        var title = this.container.querySelector('.jw-title-primary');
        var currentItem = this.jwplayer.getPlaylistItem();
        if (titleWrapper && title) {
            var titlePosition = this.playerConfig.skin.titlePosition;
            var nicamIcons = this.playerConfig.nicamIcons;
            var addTitlePadding = (0, helpers_1.nicamIconsUnderLogo)(this.playerConfig) === false &&
                (titlePosition === null || titlePosition === void 0 ? void 0 : titlePosition.includes('top')) &&
                titlePosition.valueOf() !== nicamIcons.position.valueOf();
            if (addTitlePadding) {
                var nicamWidth = (currentItem === null || currentItem === void 0 ? void 0 : currentItem.svgNicamIconsList.length)
                    ? currentItem.svgNicamIconsList.length * (nicamIcons.iconSize + 4) + nicamIcons.margin * 2
                    : 0;
                if (nicamWidth) {
                    var paddingSide = nicamIcons.position === 'top-left' ? 'padding-left' : 'padding-right';
                    titleWrapper.style[paddingSide] = "".concat(nicamWidth, "px");
                }
            }
            title.innerHTML = currentItem === null || currentItem === void 0 ? void 0 : currentItem.title;
            titleWrapper.style.display = 'block';
            title.style.display = displayTitle ? 'block' : 'none';
            this.playerConfig.displaytitle = displayTitle;
            titleWrapper.classList.add("talpa-title-".concat(titlePosition));
        }
    };
    Player.prototype.getDisplayDescription = function () {
        return this.playerConfig.displaydescription;
    };
    Player.prototype.setDisplayDescription = function (displayDescription) {
        var _a;
        if (typeof displayDescription === 'undefined') {
            return;
        }
        this.container = this.container || document.getElementById(this.clientConfig.containerId);
        if (!this.container)
            return;
        var descriptionWrapper = this.container.querySelector('.jw-title');
        var description = this.container.querySelector('.jw-title-secondary');
        if (descriptionWrapper && description) {
            description.innerHTML = ((_a = this.jwplayer.getPlaylistItem()) === null || _a === void 0 ? void 0 : _a.secondaryTitle) || '';
            descriptionWrapper.style.display = 'block';
            description.style.display = displayDescription ? 'block' : 'none';
            this.playerConfig.displaydescription = displayDescription;
        }
    };
    Player.prototype.addNicamIconsHolder = function () {
        var _a, _b;
        var nicamIconsHolder = document.querySelector('talpa-nicam-icons-container');
        if (nicamIconsHolder && nicamIconsHolder.parentNode) {
            nicamIconsHolder.parentNode.removeChild(nicamIconsHolder);
        }
        var nicamContainer = document.createElement('div');
        var nicamContainerInner = document.createElement('div');
        this.container = this.container || document.getElementById(this.clientConfig.containerId);
        var currentItem = this.jwplayer.getPlaylistItem();
        if (currentItem) {
            nicamContainer === null || nicamContainer === void 0 ? void 0 : nicamContainer.setAttribute('class', (0, helpers_1.getNicamIconsClassList)((_a = this.playerConfig) === null || _a === void 0 ? void 0 : _a.nicamIcons, currentItem.type));
        }
        nicamContainerInner.setAttribute('class', 'talpa-nicam-icons-container-inner');
        (_b = this.container) === null || _b === void 0 ? void 0 : _b.appendChild(nicamContainer);
        nicamContainer === null || nicamContainer === void 0 ? void 0 : nicamContainer.appendChild(nicamContainerInner);
        this.addNicamIconsSvgs();
    };
    Player.prototype.addNicamIconsSvgs = function () {
        var _a;
        var nicamContainerInner = document.querySelector('talpa-nicam-icons-container-inner');
        var currentItem = this.jwplayer.getPlaylistItem();
        if (((_a = currentItem === null || currentItem === void 0 ? void 0 : currentItem.svgNicamIconsList) === null || _a === void 0 ? void 0 : _a.length) > 0 && nicamContainerInner) {
            currentItem.svgNicamIconsList.map(function (svg) {
                nicamContainerInner.appendChild(svg);
            });
        }
    };
    Player.prototype.addLogoWrapper = function () {
        var _a, _b;
        if (!((_b = (_a = this.playerConfig) === null || _a === void 0 ? void 0 : _a.logo) === null || _b === void 0 ? void 0 : _b.file))
            return;
        var _c = this.playerConfig.logo, position = _c.position, classList = _c.classList, width = _c.width, link = _c.link, style = _c.style, file = _c.file, altText = _c.altText, margin = _c.margin;
        var container = this.jwplayer.getContainer();
        var anchorElement = document.createElement('a');
        container.appendChild(anchorElement);
        var logoElement = document.createElement('img');
        var title = document.querySelector('.jw-title');
        if (title) {
            var side = position.includes('left') ? 'paddingLeft' : 'paddingRight';
            title.style[side] = "".concat(width + 2 * margin, "px");
        }
        anchorElement.appendChild(logoElement);
        Object.assign(anchorElement, {
            classList: classList,
            href: link,
            target: '_blank',
            style: 'margin:0',
        });
        Object.assign(logoElement, {
            src: file,
            alt: altText,
            width: width,
            style: style,
        });
    };
    Player.prototype.addFullEpisodeButton = function () {
        var _this = this;
        var container = this.jwplayer.getContainer();
        document.querySelectorAll('.full-episode-button').forEach(function (element) { return element.remove(); });
        container.classList.remove('has-episode-button');
        var _a = this.playerConfig.fullEpisodeButton, enabled = _a.enabled, watchEpisodeOnDomain = _a.watchEpisodeOnDomain;
        var _b = this.jwplayer.getPlaylistItem(), sourceProgram = _b.sourceProgram, metadata = _b.metadata, kijkEpisodeLink = _b.kijkEpisodeLink;
        if (!enabled || !sourceProgram || !kijkEpisodeLink)
            return;
        var linkProperties = watchEpisodeOnDomain
            ? {
                onclick: function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                (0, utilities_1.trackFullEpisodeButton)(metadata);
                                return [4, this.setPlaylist([sourceProgram])];
                            case 1:
                                _a.sent();
                                this.play();
                                return [2];
                        }
                    });
                }); },
            }
            : {
                href: kijkEpisodeLink,
                target: '_blank',
                onclick: function () {
                    (0, utilities_1.trackFullEpisodeButton)(metadata);
                    _this.pause();
                },
            };
        var buttonText = (0, createElement_1.default)('span', {
            className: '',
            innerText: 'Kijk de hele aflevering',
        });
        var tagName = watchEpisodeOnDomain ? 'button' : 'a';
        var button = (0, createElement_1.default)(tagName, __assign({ className: 'full-episode-button', children: [buttonText] }, linkProperties));
        container.classList.add('has-episode-button');
        container.appendChild(button);
    };
    Player.prototype.getAutostart = function () {
        return this.playerConfig.autostart;
    };
    Player.prototype.getWidth = function () {
        this.container = this.container || document.getElementById(this.clientConfig.containerId);
        if (!this.container)
            return '';
        var computedStyles = window.getComputedStyle(this.container);
        var widthComputed = computedStyles.width;
        var widthNumber = parseInt(widthComputed.replace('px', ''));
        return widthNumber;
    };
    Player.prototype.setWidth = function (width) {
        if (width === '' || width < 0) {
            return;
        }
        this.container = this.container || document.getElementById(this.clientConfig.containerId);
        if (!this.container)
            return;
        if (typeof width === 'string') {
            this.container.style.width = width;
        }
        else if (typeof width === 'number') {
            this.container.style.width = "".concat(width, "px");
        }
        else {
            console.warn('Width value must be a string or a number');
        }
    };
    Player.prototype.getHeight = function () {
        this.container = this.container || document.getElementById(this.clientConfig.containerId);
        if (!this.container)
            return '';
        var computedStyles = window.getComputedStyle(this.container);
        var heightComputed = computedStyles.height;
        var heightNumber = parseInt(heightComputed.replace('px', ''));
        return heightNumber;
    };
    Player.prototype.setHeight = function (height) {
        if (height === '' || height < 0) {
            return;
        }
        this.container = this.container || document.getElementById(this.clientConfig.containerId);
        if (!this.container)
            return;
        if (typeof height === 'string') {
            this.container.style.height = height;
        }
        else if (typeof height === 'number') {
            this.container.style.height = "".concat(height, "px");
        }
        else {
            console.warn('Height value must be a string or a number');
        }
    };
    Player.prototype.getMute = function () {
        return this.playerConfig.mute;
    };
    Player.prototype.setMute = function (mute) {
        if (typeof mute === 'undefined') {
            return;
        }
        this.jwplayer.setMute(mute);
    };
    Player.prototype.getAspectratio = function () {
        return this.playerConfig.aspectratio || '';
    };
    Player.prototype.setAspectratio = function (ar) {
        var _a, _b;
        if (typeof ar === 'undefined') {
            return;
        }
        try {
            var arArray = ar.split(':');
            var w = arArray[0];
            var h = arArray[1];
            var wNum = parseInt(w);
            var hNum = parseInt(h);
            if (ar.indexOf(':') === -1 || typeof h === 'undefined' || !Number.isInteger(wNum) || !Number.isInteger(hNum)) {
                console.warn('Aspect ratio must be in the x:y format, where x and y are integers');
                return;
            }
            this.container = this.container || document.getElementById(this.clientConfig.containerId);
            if (!this.DOM.ratio && this.container) {
                this.DOM.ratio = this.container.querySelector('.jw-aspect');
            }
            var style = (_a = this.container) === null || _a === void 0 ? void 0 : _a.style;
            if (style && style.width.indexOf('%') === -1) {
                console.warn('You can not set aspect ratio because the player is initialized with fixed dimensions');
                return;
            }
            var ratio = parseInt(h) / parseInt(w);
            (_b = this.container) === null || _b === void 0 ? void 0 : _b.classList.add('jw-flag-aspect-mode');
            if (this.DOM.ratio) {
                this.DOM.ratio.style.paddingTop = "".concat(ratio * 100, "%");
            }
            this.playerConfig.aspectratio = ar;
        }
        catch (error) {
            console.error(error);
        }
    };
    Player.prototype.getPreload = function () {
        return this.playerConfig.preload;
    };
    return Player;
}());
exports.Player = Player;
exports.default = Player;
